
import { Component, Prop, Vue } from 'vue-property-decorator'
import { htmlClick, htmlDecode } from '@/utils/helpers'
import RobotMsgTmpl from '@/components/robot-msg-tmpl.vue'
import AnswerItem from '@/components/answer-item.vue'
import TtsAudio from '@/components/tts-audio.vue'

@Component({
  components: {
    RobotMsgTmpl,
    AnswerItem,
    TtsAudio,
  }
})
export default class HumanMsg extends Vue {
  @Prop()
  message!: string

  @Prop({ type: String, default: '' })
  robotImg!: string

  htmlDecode = htmlDecode
  /**
   *
   */
  onClick (e: Event, vm: any) {
    htmlClick(e, vm)
  }

  previewImg (src: string) {
    this.$emit('previewImg', src)
  }
}
